// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1MBkG","footer":"ModalFilter_footer__xlr02"};